import type {
  INeoActionExecutionService,
  NeoActionExecutionError,
} from "../ports/driver/neoActionExecutionService";
import type {
  INeoActionExecutionRepository,
  NeoActionExecutionListOptions,
} from "../ports/driven/neoActionExecutionRepository";

const toError = (error: unknown): NeoActionExecutionError => ({
  message: error instanceof Error ? error.message : "Something went wrong.",
});

export const NeoActionExecutionServiceImplFactory = ({
  neoActionExecutionRepository,
}: {
  neoActionExecutionRepository: INeoActionExecutionRepository;
}): INeoActionExecutionService => {
  const repo = neoActionExecutionRepository;

  const listActionExecutions = async (
    projectId: number,
    opts?: NeoActionExecutionListOptions
  ) => {
    try {
      const resp = await repo.listActionExecutionsAPI(projectId, opts);
      return { success: true, data: resp?.items ?? [] };
    } catch (error) {
      return { success: false, error: toError(error) };
    }
  };

  const approveActionExecution = async (executionId: number) => {
    try {
      const data = await repo.approveActionExecutionAPI(executionId);
      return { success: true, data };
    } catch (error) {
      return { success: false, error: toError(error) };
    }
  };

  const rejectActionExecution = async (
    executionId: number,
    reason?: string
  ) => {
    try {
      const data = await repo.rejectActionExecutionAPI(executionId, reason);
      return { success: true, data };
    } catch (error) {
      return { success: false, error: toError(error) };
    }
  };

  const undoActionExecution = async (executionId: number) => {
    try {
      const data = await repo.undoActionExecutionAPI(executionId);
      return { success: true, data };
    } catch (error) {
      return { success: false, error: toError(error) };
    }
  };

  return {
    listActionExecutions,
    approveActionExecution,
    rejectActionExecution,
    undoActionExecution,
  };
};
